import type {QueryParams} from '@jetbrains/teamcity-ui/dist/utils'

import {preloadEditPipelinePage} from '../EditPipelinePage/EditPipelinePage.preload'

import type {AppThunk} from 'src/actions/types'
import type {LoadedEndpoints} from 'src/routes/loadEndpoint'
import type {PipelineId} from 'src/types'

export const preloadPipelinePage =
  (pipelineId: PipelineId, queryParams: QueryParams): AppThunk<LoadedEndpoints> =>
  dispatch => {
    const {edit} = queryParams
    return edit === 'true' ? dispatch(preloadEditPipelinePage(pipelineId, queryParams)) : []
  }
